module.exports = __webpack_public_path__ + "static/img/single.78bca29a.svg";